var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "BatchBillingListEditor",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    id: _vm.formId,
                    name: _vm.formName,
                    autofocus: "first"
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "fulfillment_date",
                        label: _vm._f("gettext")("Fulfillment Date"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        required: "",
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "fulfillment_date_enabled" },
                              model: {
                                value: _vm.item.$updates.fulfillment_date,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.$updates,
                                    "fulfillment_date",
                                    $$v
                                  )
                                },
                                expression: "item.$updates.fulfillment_date"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormDatetime", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "fulfillment_date",
                          disabled: !_vm.item.$updates.fulfillment_date
                        },
                        model: {
                          value: _vm.item.fulfillment_date,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "fulfillment_date", $$v)
                          },
                          expression: "item.fulfillment_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "due_date",
                        label: _vm._f("pgettext")("Due Date", "Invoice"),
                        labelColsMd: "4",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        required: "",
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "due_date_enabled" },
                              model: {
                                value: _vm.item.$updates.due_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "due_date", $$v)
                                },
                                expression: "item.$updates.due_date"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormDatetime", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "due_date",
                          disabled: !_vm.item.$updates.due_date
                        },
                        model: {
                          value: _vm.item.due_date,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "due_date", $$v)
                          },
                          expression: "item.due_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.item.billing_period
                    ? _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "billing_period",
                            label: _vm._f("gettext")("Billing Period"),
                            contentClass: "input-group",
                            labelColsMd: "4",
                            contentColsMd: "8",
                            labelAlign: _vm.labelAlign
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "billing_period_enabled" },
                                  model: {
                                    value: _vm.item.$updates.billing_period,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "billing_period",
                                        $$v
                                      )
                                    },
                                    expression: "item.$updates.billing_period"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row" },
                            [
                              _c(
                                "DIV",
                                { staticClass: "col-4" },
                                [
                                  _c("ItpFormDatetime", {
                                    attrs: {
                                      name: "billing_period_start",
                                      placeholder: _vm._f("pgettext")(
                                        "From",
                                        "BillingPeriod"
                                      ),
                                      disabled: !_vm.item.$updates
                                        .billing_period
                                    },
                                    model: {
                                      value: _vm.item.billing_period.start,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.item.billing_period,
                                          "start",
                                          $$v
                                        )
                                      },
                                      expression: "item.billing_period.start"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "DIV",
                                { staticClass: "col-4" },
                                [
                                  _c("ItpFormDatetime", {
                                    attrs: {
                                      name: "billing_period_end",
                                      placeholder: _vm._f("pgettext")(
                                        "To",
                                        "BillingPeriod"
                                      ),
                                      disabled: !_vm.item.$updates
                                        .billing_period
                                    },
                                    model: {
                                      value: _vm.item.billing_period.end,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.item.billing_period,
                                          "end",
                                          $$v
                                        )
                                      },
                                      expression: "item.billing_period.end"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      staticClass: "col",
                      attrs: {
                        name: "currency",
                        label: _vm._f("pgettext")("Currency", "Invoice"),
                        labelColsMd: "4",
                        contentColsMd: "3",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "currency_enabled" },
                              model: {
                                value: _vm.item.$updates.currency,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "currency", $$v)
                                },
                                expression: "item.$updates.currency"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormSelect", {
                        attrs: {
                          name: "currency",
                          options: _vm.currencies,
                          valueField: "code",
                          textField: "code",
                          disabled: !_vm.item.$updates.currency
                        },
                        model: {
                          value: _vm.item.currency,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "currency", $$v)
                          },
                          expression: "item.currency"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      staticClass: "col",
                      attrs: {
                        name: "currency",
                        label: _vm._f("pgettext")("Exchange rate", "Invoice"),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "exchange_rate_enabled" },
                              model: {
                                value: _vm.item.$updates.exchange_rate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.item.$updates,
                                    "exchange_rate",
                                    $$v
                                  )
                                },
                                expression: "item.$updates.exchange_rate"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row" },
                        [
                          _c(
                            "DIV",
                            { staticClass: "col-3" },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  mask: "number",
                                  unmask: "typed",
                                  scale: "2",
                                  name: "exchange_rate",
                                  readonly: _vm.isReadonly,
                                  placeholder: _vm._f("pgettext")(
                                    "Rate",
                                    "Invoice"
                                  ),
                                  disabled: !_vm.item.$updates.exchange_rate
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.evh_4397690859646801_blur(
                                      $event,
                                      {}
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.exchange_rate.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.exchange_rate, "value", $$v)
                                  },
                                  expression: "exchange_rate.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "DIV",
                            { staticClass: "col-4" },
                            [
                              _c("ItpFormDatetime", {
                                attrs: {
                                  name: "exchange_rate_date",
                                  readonly: _vm.isReadonly,
                                  placeholder: _vm._f("pgettext")(
                                    "Date",
                                    "Invoice"
                                  ),
                                  disabled: !_vm.item.$updates.exchange_rate
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.evh_4067533979448964_blur(
                                      $event,
                                      {}
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.exchange_rate.date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.exchange_rate, "date", $$v)
                                  },
                                  expression: "exchange_rate.date"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "DIV",
                            { staticClass: "col-5" },
                            [
                              _c("ItpFormSelect", {
                                attrs: {
                                  name: "exchange_rate_source",
                                  options: _vm.exchangeRateSources,
                                  readonly: _vm.isReadonly,
                                  placeholder: _vm._f("pgettext")(
                                    "Source",
                                    "ExchangeRateFieldset"
                                  ),
                                  valueField: "value",
                                  textField: "name",
                                  "null-option": "",
                                  disabled: !_vm.item.$updates.exchange_rate
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.evh_8826227742204642_blur(
                                      $event,
                                      {}
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.exchange_rate.source,
                                  callback: function($$v) {
                                    _vm.$set(_vm.exchange_rate, "source", $$v)
                                  },
                                  expression: "exchange_rate.source"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr", { staticClass: "my-4" }),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      staticClass: "col",
                      attrs: {
                        name: "notes",
                        label: _vm._f("pgettext")("Notes", "Invoice"),
                        labelColsMd: "4",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "notes_enabled" },
                              model: {
                                value: _vm.item.$updates.notes,
                                callback: function($$v) {
                                  _vm.$set(_vm.item.$updates, "notes", $$v)
                                },
                                expression: "item.$updates.notes"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormTextarea", {
                        attrs: {
                          name: "notes",
                          disabled: !_vm.item.$updates.notes
                        },
                        model: {
                          value: _vm.item.notes,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "notes", $$v)
                          },
                          expression: "item.notes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Save", "Button"),
                  disabled:
                    !_vm.forms[_vm.formName] ||
                    !_vm.forms[_vm.formName].submittable,
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.save.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }